import { EnumBasedItem, createEnumService } from "./base";

export enum ValidityCalculationType {
  ALL_PARTS = "all_parts",
  E_LEARNING = "e-learning",
}

export class ValidityCalculation extends EnumBasedItem<ValidityCalculationType> {}

const validityCalculationService = createEnumService(ValidityCalculationType, ValidityCalculation);
export default validityCalculationService;
